import { render } from "./InformationStep.vue?vue&type=template&id=085aff9e"
import script from "./InformationStep.vue?vue&type=script&lang=js"
export * from "./InformationStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__